/**
 * Do not edit directly
 * Generated on Fri, 17 Jul 2026 14:14:12 GMT
 */

export const xs = "4px";
export const sm = "8px";
export const md = "16px";
export const lg = "32px";
export const xl = "64px";
